











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import MazeCell, {CellContent} from './MazeCell.vue';
import GridCell from '../classes/GridCell';

export {CellContent};

@Component({components: {MazeCell}})
export default class MazeGrid extends Vue {
    @Prop({default: []}) private cells!: GridCell[];

    private onCellClicked(cell: GridCell): void {
        this.$emit('cell-clicked', cell);
    }

    private get columnCount(): number {
        return Math.floor(this.cells.length ** 0.5);
    }
}
